export const OFFSET_LIMIT = 30

export const appname = "jieligo"
// export const appname = 'bushubao'

console.log(process.env.NODE_ENV)

export const QQ_MAP_KEY = "UL7BZ-EJCKP-CIQD3-LUJUC-OLQ2F-26BFS"

export const authkey = "1IUNQug7BiSdtoF27Vx9ljNSXKid3T8W"
export const platform = "h5"

export const UnImageSrc = "https://jieligo-1259536745.picgz.myqcloud.com/uploads/tuan/uD7s5UdrWw.png"
console.log("process.env.NODE_ENV :>> ", process.env.NODE_ENV)

export const API = (() => {
  let state = ""
  if (process && process.env && process.env.NODE_ENV) state = process.env.NODE_ENV
  const { host, port } = window.location
  // if (host === 'www.jieligo.net') return 'https://test.groupai.net'
  if (host === "www.jieligo.net") return "https://api.jieligo.net"
  if (host === "jieligo-15d47a-1259536745.tcloudbaseapp.com") return "https://test.groupai.net"
  // if (host === 'jieligo-15d47a-1259536745.tcloudbaseapp.com') return 'https://test.jieligo.net'
  if (port === "3001") {
    // return 'https://api.jieligo.net'
    // return 'https://dev.jieligo.net'
    // return 'http://www.tuan.com/index.php'
    // return 'https://test.jieligo.net'
    // return 'https://test.groupai.net'
  }
  switch (state) {
    case "development":
      // return 'https://api.jieligo.net'
      // return 'https://dev.jieligo.net'
      // return "https://test.jieligo.net"; // 测试数据库
      // return "https://test.groupai.net";
      // return 'http://localhost:3001';
      return "http://localhost:3001/web/index.php"
    // return "https://api-jlg.lingshu365.com" // newer
    // return "https://api.jieligo.net/"; // 借用灵树AI生产环境
    // return 'https://api.jieligo.net'
    // return 'http://www.tuan.com/index.php'
    // eslint-disable-next-line no-fallthrough
    default:
      if (host.indexOf("test") !== -1) {
        return "http://api-test.lingshu365.com"
      }
      return "https://api-jlg.lingshu365.com"
    // return "https://api.jieligo.net";
  }
})()

/** 测试环境 */
export const isTestEnv = API.indexOf("api-test") !== -1 || process.env.NODE_ENV === "development"
console.log("isTestEnv :>> ", isTestEnv)
export let testToken = "" // 测试用token, 在 <Login /> 组件中调用
export function setTestToken(t) {
  if (!isTestEnv) return
  localStorage.setItem("token", t)
  console.log("setTestToken :>> ", t)
  // 刷新
  window.location.reload()
}
// 527E684CADCEA50FF032FE7732BDBC
export const DEFAULT_LOGO = "https://jieligo-1259536745.picgz.myqcloud.com/uploads/icbc/IIUOQ8hHqY.png?imageView2/5/w/200"
